export default function initSlider() {
  const LISTS = document.querySelectorAll('.slider')

  LISTS.forEach((LIST) => {
    if (LIST) {
      const scrollStep = 1
      const intervalTime = 28

      LIST.innerHTML += LIST.innerHTML

      LIST.addEventListener('mouseenter', () => {
        LIST.classList.add('hover')
      })

      LIST.addEventListener('mouseleave', () => {
        LIST.classList.remove('hover')
      })

      setInterval(() => {
        if (LIST.classList.contains('hover')) return

        LIST.scrollLeft += scrollStep

        if (LIST.scrollLeft >= LIST.scrollWidth / 2) {
          LIST.scrollLeft = 0
        }
      }, intervalTime)
    }
  })
}
